import { useQuery } from "@tanstack/react-query";
import { UserService } from "./user.service";
import { UserPermissionsByRoleDTO } from "modules/Campaigns/service/campaigns.types";

export const useUserPermissions = () =>
  useQuery<UserPermissionsByRoleDTO>({
    queryKey: ["userPermissionsByRole"],
    queryFn: UserService.getUserPermissionByRole,
    staleTime: 5 * 60 * 1000,
  });